import React, { useEffect, useState,useRef } from "react";
import BottomNav from "../components/BottomNav";
import Container from "../components/Container";
import Description from "../components/Description";
import FinancialHealthCheckup from "../components/FinancialHealthCheckup";
import Heading from "../components/Heading";
import Input from "../components/Input";
import PieGraph from "../components/PieGraph";
import ResultInput from "../components/ResultInput";
import { BarChart, Bar, XAxis, YAxis, ReferenceLine, Cell, ResponsiveContainer } from 'recharts';
import LineChart from "../components/LineChart";
import DMPieGraph from "../components/DMPieGraph";
import { Form } from "react-router-dom";

import { DMLineChart } from "../components/DMLineChart";
import Test from "../components/MultipleAxisGraph";
import MultipleAxisGraph from "../components/MultipleAxisGraph";
// import  DemoDMLineChart  from "../components/DemoDMLineChart.";
import LineChartPrac from "../components/LineChartPrac";
import {useSelector,useDispatch} from 'react-redux'
import  { actions } from '../store/index'
import YourFHC from "../components/YourFHC";
import { Link } from "react-router-dom";


const KFormater = (num) => Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
    return <text x={x + width / 2} y={y} fill="#0A1827" textAnchor="middle" dy={value < 0 ? 16 : -6} >{`${value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}</text>;
};

const DM = () => {

    const counter=useSelector((state)=>state.formdata)
    const dispatch=useDispatch()
    const hasCodeExecuted = useRef(false);

    const [selects,setselects]=useState();
    

    const [formData, setFormData] = useState({
        M1: 0,
        M2: 0,
        M3: 0,
        M4: 0,
        T1: 0,
        T2: 0,
        T3: 0,
        T4: 0,
  
    
    });

    const [data,setData]=useState({
        CLAPR: 0,
        CLA: 0,
        CLT: 0,
        CCDAPR: 0,
        CCDA: 0,
        CCDT: 0,
        PLAPR: 0,
        PLA: 0,
        PLT: 0,
        ELAPR: 0,
        ELA: 0,
        ELT: 0,
        MAPR: 0,
        MA: 0,
        MT: 0,
        months: 0
    })

    

    const [resultData, setResultData] = useState({
        R1: 0,
        R2: 0,
        R3: 0,
        R4: 0,
        R5: 0,
        R2Less: 0,
        saving:0
    });

    const inputElement = document.getElementById('ELA');
   


    const [LineChartValues,setLineChartValues]=useState([])

     
    const [months,setMonths]=useState([])
    const [PayableLoans,setPayableLoans]=useState([])

    function getNextMonths(n) {
        const today = new Date();
      
        setMonths([])
        let totalMonths=[]
        for (let i = 0; i < n; i++) {
          const nextMonth = new Date(today.getFullYear(), today.getMonth() + i + 1, 1);
          const month = nextMonth.toLocaleString('default', { month: 'long' });
          const year = nextMonth.getFullYear();
          totalMonths.push(`${month} ${year}`)
        }
        
        setMonths(totalMonths)
      }

    const [Slack, setSlack] = useState(0)
    const [Slack2, setSlack2] = useState(0)
    const [Networth, setNetworth] = useState(0);
    

    const changeHandler = (e) => {
        // if(e.target.id==="T1")
        // {
        //     window.alert(e.target.value)
        //     // e.target.value=0

        // }
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };

    const dataChangeHandler = (e) => {
        // if(e.target.id==="T1")
        // {
        //     window.alert(e.target.value)
        //     // e.target.value=0

        // }
        setData({
            ...data,
            [e.target.id]: e.target.value
        });
    };

    const [selectedOption, setSelectedOption] = useState("Snowball");

    const [check,setCheck]=useState(false)

    const handleSelectChange = (event) => {
        console.log(selectedOption)
      setSelectedOption(event.target.value);
    };

    const update=()=>
    {
        Object.keys(counter).length>0?
        setFormData(counter):
        setFormData(formData)
    }


    useEffect(() => {
        if (!hasCodeExecuted.current) {

            update()
            hasCodeExecuted.current = true;
            window.scrollTo(0, 0);

        }
        
        const { M1, M2, M3, M4, T1, T2, T3, T4 } = formData;
        setResultData({
            R1: (Number(M3) / Number(M1)) * 100,
            R2: Number(T1) / (Number(M2) + Number(M3) + Number(M4))*100,
            R3: ((Number(T1) + Number(T2)) / (Number(T3) + Number(T4)) * 100),
            R4: (Number(T1) / (Number(M3) + Number(M4)) * 100),
            R5: (Number(M4) / Number(M1) * 100),
            R2Less:((3*(Number(formData.M2)+(Number(formData.M3))+(Number(formData.M4))))-Number(formData.T1))/Number(Slack),
             saving: Number(formData.T1)-(3*(Number(formData.M2)+Number(formData.M3)+Number(formData.M4)))

        });
        const T11 =Number(formData.T1)
        setCartData([{
            name: 'Car Loan',
            value: Number(data.CLA),
            color: "orange"
        },
        {
            name: 'Credit Card Debt',
            value: Number(data.CCDA),
            color: "orange"
        },
        {
            name: 'Personal Loan',
            value: Number(data.PLA),
            color: "orange"
        },
        {
            name: 'Educational Loan',
            value: Number(data.ELA),
            color: "orange"
        }]);

        

        setSlack(Number(M1) - (Number(M2) + Number(M3) + Number(M4)));

        function Snowball(values)
        {
            setLineChartValues([])
            setPayableLoans([])
        
            let savings=resultData.saving
        //    alert(savings)
            let flag=0
            let month=0
            let LineVals=[]
            let loans=[]
            let flag2=0

            values=values.filter(value => value.amount > 0).sort((a, b) => a.amount - b.amount);
            // console.log(values)
            values.map((value)=>
            {
            
            if(savings>Number(value.amount))
            {
                savings=savings-Number(value.amount)
                
                let stat=`${value.name} of ${value.amount} can be paid off immediately using extra savings. `
                loans.push(stat)
                setSlack2(Slack)
            //    alert(value.name)
               
            }
            else if(savings===Number(value.amount))
            {
                let stat=`${value.name} of ${value.amount} can be paid off immediately using extra savings. `
                value.amount=Number(value.amount)-savings
                savings=-1
                loans.push(stat)
                flag=1
                flag2=-1


                
            }
            else if(savings>=0)
            {
                flag=1
                value.amount=Number(value.amount)-Number(savings)
                // window.alert(value.name)
                let stat=``
                stat=`A part of ${value.name} of ${savings} can be paid off using extra savings. `
               if(Number(value.amount)-Number(Slack)<=0)
               {
                // setSlack2(Number(Slack)-Number(value.amount))
                stat+=`Remaining ${value.name} of ${value.amount} can be paid off immediately using slack this month. `
               }
               else
               {
                // setSlack2(0)
               }
               flag2=1
       

                loans.push(stat)
                savings=-1

            }

            if(flag===1)
            {
                let stat=``
                // stat=` ${value.name} of $${value.amount} can be paid off with slack in ${Number(value.amount)/Number(Slack)} months. `
                if(flag2===0)
                {
                //    setSlack(0)
                   
                    stat=` ${value.name} of ${value.amount} can be paid off with slack in ${(Number(value.amount)/Number(Slack)).toFixed(0)} months. `
                }
                else
                {
                    let mon=((Number(value.amount)-Number(Slack))/Number(Slack)).toFixed(0)
               
                    if(mon>0)
                    {
                        // setSlack2(Number(Slack)-Number(value.amount))
                        stat=`Remainig ${value.name} of ${Number(value.amount)-Number(Slack)} can be paid off with slack in ${((Number(value.amount)-Number(Slack))/Number(Slack)).toFixed(0)} months. `
                    }
                    flag2=0

                }
                // alert(stat)
                loans.push(stat)



                LineVals.push({name:value.name,amount:Number(value.amount)})
                setLineChartValues(LineVals)
             month=Number(month)+(Number(value.amount)/Number(Slack))
            //  console.log(month)
            }
            })

            console.log(loans)
            setPayableLoans(loans)

            data.months=Number(month)
            getNextMonths(Number(month))
            console.log(months)


        }

        function Avalanche(values)
        {
            setLineChartValues([])
            setPayableLoans([])

            let LineVals=[]
            let savings=resultData.saving
            let flag=0
            let month=0
            let loans=[]
            let flag2=0

            values=values.filter(value => value.apr > 0).sort((a, b) => b.apr - a.apr);
            // console.log(values)
            values.map((value)=>
            {
            console.log(value.amount)

            if(savings>Number(value.amount))
            {
                savings=Number(savings)-Number(value.amount)

                let stat=`${value.name} of ${value.amount} can be paid off immediately using extra savings. `
                loans.push(stat)
                // value.apr=0
            }
            // else if(savings===Number(value.amount))
            // {
            //     value.amount=Number(value.amount)-savings
            //     savings=-1
            //     let stat=`${value.name} can be paid off immediately. `
            //     loans.push(stat)
            //     flag=1
                
            // }

               else if(savings===Number(value.amount)&& savings>0)
               {
                let stat=`${value.name} of ${value.amount} can be paid off immediately using extra savings. `
                value.amount=Number(value.amount)-savings
                savings=-1
                loans.push(stat)
                flag=1
                flag2=-1
                // value.apr=0
                // alert(value.apr)
                
            }
            
            else if(savings>=0)
            {
                
                value.amount=Number(value.amount)-Number(savings)
                let stat=`A part of ${value.name} of ${savings} can be paid off using extra savings. `
                
                if(Number(value.amount)-Number(Slack)<=0)
                {
                 stat+=`Remaining ${value.name} of ${value.amount} can be paid off immediately using slack this month. `
                }
                flag2=1
        
                
                savings=-1
                loans.push(stat)
                flag=1
            }
       

            if(flag===1)
            {

                let stat=``
                if(flag2===0)
                {

                    stat=` ${value.name} of ${value.amount} can be paid off with slack in ${(Number(value.amount)/Number(Slack)).toFixed(0)} months. `
                }
                else
                {
                    let mon=((Number(value.amount)-Number(Slack))/Number(Slack)).toFixed(0)
                    if(mon>0)
                    {
                    stat=`Remainig ${value.name} of ${Number(value.amount)-Number(Slack)} can be paid off with slack in ${((Number(value.amount)-Number(Slack))/Number(Slack)).toFixed(0)} months. `
                    }
                    flag2=0

                }
                loans.push(stat)
              if(value.amount>0)
              {

                  LineVals.push({name:value.name,amount:Number(value.amount),apr:Number(value.apr)})
                  setLineChartValues(LineVals)
                  month=Number(month)+(Number(value.amount)/Number(Slack))
                }
            //  console.log(month)
            }
            })

            setPayableLoans(loans)

            data.months=Number(month)
            getNextMonths(Number(month))
            console.log(months)
            // alert(LineVals[0])


        }
        


        function checkAmount()
        {
            if((data.ELA || data.CLA || data.CCDA || data.PLA) && formData.T3)
            {
        
                const sum=(Number(data.CLA)+Number(data.CCDA)+Number(data.PLA)+Number(data.ELA))
                if((sum)!==Number(formData.T3))
                {
                 setCheck(true)
                }
                else
                {
                    setCheck(false)
                }
            }
            else
            {
                setCheck(false)
            }
        }

        checkAmount()
       
  
        // inputElement.addEventListener('focusout', (event) => {
            // Code to be executed when the input element loses focus
            const sum=(Number(data.CLA)+Number(data.CCDA)+Number(data.PLA)+Number(data.ELA))
            console.log(sum)
            if(sum==Number(formData.T3))
            {
                
          
            if(Number(resultData.R2).toFixed(0)>300)
            {
                if(selectedOption==="Snowball")
                {
                    Snowball([
                        {name:'Car Loan', apr:data.CLAPR,amount:data.CLA},
                        {name:'Credit Card Loan', apr:data.CCDAPR,amount:data.CCDA},
                        {name:'Personal Loan' ,apr:data.PLAPR,amount:data.PLA},
                        {name:'Educational Loan', apr:data.ELAPR,amount:data.ELA}]
                        )
                }
                
                else
                {
                    Avalanche([
                        {name:'Car Loan', apr:data.CLAPR,amount:data.CLA},
                        {name:'Credit Card Loan', apr:data.CCDAPR,amount:data.CCDA},
                        {name:'Personal Loan' ,apr:data.PLAPR,amount:data.PLA},
                        {name:'Educational Loan', apr:data.ELAPR,amount:data.ELA}]
                        )
                }
                
            }
        }
       
        // if(Number(formData.T3)>0 && Number(data.CLA) >0 &&Number(data.CCDA)>0 && Number(data.PLA)>0 &&Number(data.ELA)>0 )
        // {
        else if(sum>Number(formData.T3) || sum<Number(formData.T3))
            {
                // if(check===false)
                // {
                 

                        // window.alert('Your total loan amount should be equal total of all loans.')
             
                //     setCheck(true)
                // }
                if(Number(resultData.R2).toFixed(0)>300)
                {
                    if(selectedOption==="Snowball")
                    {
                        Snowball([
                            {name:'Car Loan', apr:data.CLAPR,amount:data.CLA},
                            {name:'Credit Card Loan', apr:data.CCDAPR,amount:data.CCDA},
                            {name:'Personal Loan' ,apr:data.PLAPR,amount:data.PLA},
                            {name:'Educational Loan', apr:data.ELAPR,amount:data.ELA}]
                            )
                    }
                    
                    else
                    {
                        Avalanche([
                            {name:'Car Loan', apr:data.CLAPR,amount:data.CLA},
                            {name:'Credit Card Loan', apr:data.CCDAPR,amount:data.CCDA},
                            {name:'Personal Loan' ,apr:data.PLAPR,amount:data.PLA},
                            {name:'Educational Loan', apr:data.ELAPR,amount:data.ELA}]
                            )
                    }
                    
                }
        
            }
           
        // }
    
          
        //   });
        console.log('payable Loans ', PayableLoans)
        dispatch(actions.updateFormData(formData))
    
        
        setNetworth((Number(T1) + Number(T2)) - Number(T3));
    }, [formData, Slack,selectedOption,resultData.saving,data]);


    const [chartData, setCartData] = useState([{
        name: 'Car Loan',
        value: Number(data.CLA),
        color: "#404EED"
    },
    {
        name: 'Credit Card Debt',
        value: Number(data.CCDA),
        color: "#404EED"
    },
    {
        name: 'Personal Loan',
        value: Number(data.PLA),
        color: "#404EED"
    },
    {
        name: 'Educational Loan',
        value: Number(data.ELA),
        color: "#404EED"
    }]);




   
    return (
        <div className="w-full ">
            <div className="bg-gradient-to-b h-72 from-primary to-patric-blue">
                <Container classes={"flex flex-col p-4 px-5 space-y-6 md:space-y-0  md:py-10 md:flex-row items-center w-full justify-between"}>
                    <div className="w-full md:w-auto">
                        <Link to={'/'}>    
                        <img src="./assets/images/logo-white.png" alt="logo" />
                        </Link>
                        
                        </div>
                    <h1 className="text-white font-bold text-center text-2xl md:text-4xl">Debt Management</h1>
                    <div className="hidden md:block"></div>
                </Container>
                <div className="text-white  text-center mb:mx-0 mx-5 md:ml-40 -mt-3 md:-mt-7 text-lg md:text-2xl">Take control of your debt. You can pay it off and be debt-free </div>

            </div>
            <Container classes={"-mt-24 md:-mt-32 py-10 space-y-6"}>

            <div className="flex flex-col md:flex-row items-start space-y-10 md:space-y-0 md:space-x-6">
                    <div className="flex-1 w-full md:flex md:space-x-10 md:space-y-0 space-y-10 ">
                        <div className="shadow-md p-6 bg-white space-y-6">
                            <Heading text={"Basic Financial Inputs"} icon={"financial-input"} />
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-20">
                                <Input type={"number"} id={"M1"} value={formData.M1} label={"Monthly Income"} onChange={changeHandler} />
                                <Input type={"number"} id={"T1"} value={formData.T1} label={"Total Savings (Liquid Funds)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M2"} value={formData.M2} label={"Monthly Expenses"} onChange={changeHandler} />
                                <Input type={"number"} id={"T2"} value={formData.T2} label={"Stocks, bonds, real estate etc."} onChange={changeHandler} />
                                <Input type={"number"} id={"M3"} value={formData.M3} label={"Monthly Debt pmt (credit card, car etc)"} onChange={changeHandler} />
                                <Input type={"number"} id={"T3"} value={formData.T3} label={"Total Debt (except mortgage)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M4"} value={formData.M4} label={"Housing / Rent, Tax, Inurance"} onChange={changeHandler} />
                                <Input type={"number"} id={"T4"} value={formData.T4} label={"Mortgage Balance"} disable onChange={changeHandler} />
                            </div>
                        </div>
                           

<YourFHC R1={resultData.R1} R2={resultData.R2} R3={resultData.R3} R4={resultData.R4} R5={resultData.R5} Slack={Slack}/>
             
                        
                      
                        
                    </div>

                </div>
                <Heading text={"Loan Information"} />
                <div >
                    <div className="md:flex hidden ml-28 ">
                    <h1 className="text-primary text-center text-2xl font-bold  md:ml-96 md:mr-6">APR</h1>
                    <h1 className="text-primary text-center text-2xl font-bold  md:ml-64 md:mr-6 ">Amount</h1>
                    <h1 className="text-primary text-center text-2xl font-bold  md:ml-64 ">Tenure</h1>


                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-10 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-0 md:grid hidden ">
                        <h1 className="text-primary text-center text-2xl font-bold  md:mt-7 md:ml-28 ">Car Loan</h1>
                  
                        <Input type={"number"}  id={"CLAPR"} value={data.CLAPR}  onChange={dataChangeHandler} />
                        <Input type={"number"} id={"CLA"} value={data.CLA}  onChange={dataChangeHandler} />
                        <Input type={"number"} id={"CLT"} value={data.CLT}  onChange={dataChangeHandler} />


                    </div>
                    
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-10 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-0 md:hidden grid">
                        <h1 className="text-primary text-center text-2xl font-bold  md:mt-3 md:ml-28 ">Car Loan</h1>
                          <Input label={"Apr"} type={"number"} id={"CLAPR"} value={data.CLAPR}  onChange={dataChangeHandler} />
                        <Input label={"Amount"} type={"number"} id={"CLA"} value={data.CLA}  onChange={dataChangeHandler} />
                        <Input label={"Tenure"} type={"number"} id={"CLT"} value={data.CLT}  onChange={dataChangeHandler} />

                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-10 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-0 md:grid hidden">
                        <h1 className="text-primary text-center  text-2xl font-bold mt-5 md:mt-7 md:ml-5">Credit Card Debt</h1>
                        <Input type={"number"} id={"CCDAPR"} value={data.CCDAPR}  onChange={dataChangeHandler} />
                        <Input type={"number"} id={"CCDA"} value={data.CCDA}  onChange={dataChangeHandler} />
                        <Input type={"number"} id={"CCDT"} value={10} disable onChange={dataChangeHandler} />

                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1  md:px-0 px-10 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-0 mt-5 md:hidden grid">
                        <h1 className="text-primary text-center text-2xl font-bold  md:mt-3 md:ml-28 ">Credit Card Debt</h1>
                        <Input label={"Apr"} type={"number"} id={"CCDAPR"} value={data.CCDAPR}  onChange={dataChangeHandler} />
                        <Input label={"Amount"} type={"number"} id={"CCDA"} value={data.CCDA}  onChange={dataChangeHandler} />
                        <Input label={"Tenure"}type={"number"} id={"CCDT"} value={10} disable onChange={dataChangeHandler} />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-10 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-0 md:grid hidden">
                        <h1 className="text-primary text-center text-2xl font-bold mt-5 md:mt-7 md:ml-14">Personal Loan</h1>
                        <Input type={"number"} id={"PLAPR"} value={data.PLAPR}  onChange={dataChangeHandler} />
                        <Input type={"number"} id={"PLA"} value={data.PLA}  onChange={dataChangeHandler} />
                        <Input type={"number"} id={"PLT"} value={data.PLT}  onChange={dataChangeHandler} />

                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-10 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-0 mt-5 md:hidden grid">
                        <h1 className="text-primary text-center text-2xl font-bold  md:mt-3 md:ml-28 ">Personal Loan</h1>
                        <Input label={"Apr"} type={"number"} id={"PLAPR"} value={data.PLAPR}  onChange={dataChangeHandler} />
                        <Input label={"Amount"} type={"number"} id={"PLA"} value={data.PLA}  onChange={dataChangeHandler} />
                        <Input label={"Tenure"}type={"number"} id={"PLT"} value={data.PLT}  onChange={dataChangeHandler} />

                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-10 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-0  md:grid hidden">
                        <h1 className="text-primary text-center text-2xl font-bold mt-5 md:mt-7 md:ml-5">Educational Loan</h1>
                        <Input type={"number"} id={"ELAPR"} value={data.ELAPR}  onChange={dataChangeHandler} />
                        <Input type={"number"} id={"ELA"} value={data.ELA}  onChange={dataChangeHandler} />
                        <Input type={"number"} id={"ELT"} value={data.ELT}  onChange={dataChangeHandler} />

                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-10 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-0 mt-5 md:hidden grid">
                        <h1 className="text-primary text-center text-2xl font-bold  md:mt-3 md:ml-28 ">Educational Loan</h1>
                        <Input label={"Apr"} type={"number"} id={"ELAPR"} value={data.ELAPR} onChange={dataChangeHandler} />

                        <Input label={"Amount"} type={"number"} id={"ELA"} value={data.ELA} onChange={dataChangeHandler} />

                        <Input label={"Tenure"} type={"number"} id={"ELT"} value={data.ELT} onChange={dataChangeHandler} />
                    </div>


                    {check? 
                     <div className="flex justify-center md:ml-96 mt-5 text-red-devil">
                        <p>Your Total amount should be equal to the Total Debt</p>
                    </div>:''
                    
                }

                    {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-10 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-16 md:grid hidden">
                        <h1 className="text-primary text-center text-2xl font-bold mt-5 md:mt-7 md:ml-28">Mortgage</h1>
                        <Input type={"number"} id={"MAPR"} value={data.MAPR}  onChange={dataChangeHandler} isLast/>
                        <Input type={"number"} id={"MA"} value={data.MA}  onChange={dataChangeHandler} isLast/>
                        <Input type={"number"} id={"MT"} value={data.MT}  onChange={dataChangeHandler} isLast/>

                    </div> */}

                   

                    {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-10 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-16 md:hidden grid">
                        <h1 className="text-primary text-center text-2xl font-bold mt-5 md:mt-3 md:ml-28">Mortgage</h1>
                        <Input label={"Apr"} type={"number"} id={"MAPR"} value={data.MAPR}  onChange={dataChangeHandler} isLast/>
                        <Input label={"Amount"} type={"number"} id={"MA"} value={data.MA}  onChange={dataChangeHandler} isLast/>
                        <Input label={"Tenure"}type={"number"} id={"MT"} value={data.MT}  onChange={dataChangeHandler} isLast/>

                    </div> */}

                    <div className="mb-24 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 md:px-10 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-24 ml-10 md:ml-60   md:grid  flex-col">
                    <label className="peer-focus:text-primary  text-chinese-black/70  text-2xl  font-bold mt-5 md:mt-3 md:ml-96 w-8/12 ">Preferred Debt Payoff Method</label>
                    <select className=" bg-primary text-white  w-6/12 md:ml-64 text-gray-900 text-sm text-center text-lg py-5 rounded-2xl focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:placeholder-gray-400 dark:text-white focus:outline-primary outline-primary"onChange={handleSelectChange} >
                    <option selected value="Snowball">Snowball</option>
                    <option value="Avalanche">Avalanche</option>
                    </select>   

                    </div>
                  
                    {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-0 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-20 md:mt-16 mt-10 md:hidden grid ">
                    <label className="peer-focus:text-primary  text-chinese-black/70 font-bold mt-5 md:mt-3 md:ml-96 w-full ">Preferred Debt Payoff Method</label>
                    <select className=" bg-primary text-white  w-full md:ml-64 text-gray-900 text-sm text-center text-lg py-5 rounded-2xl focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:placeholder-gray-400 dark:text-white focus:outline-primary outline-primary"onChange={handleSelectChange} >
                    <option selected value="Snowball">Snowball</option>
                    <option value="Avalanche">Avalanche</option>
                    </select>   

                    </div> */}

                    <div>
                        
                    </div>
                </div>

                <div className="block md:flex   px-5">

                    <div className="hidden md:block w-7/12">
                            <PieGraph heading="Current Cash Flow Distribution" subheading="" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} slack={Slack} />
                        </div>
                        <div className="md:hidden">
                            <PieGraph heading="Current Cash Flow Distribution" subheading="" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} slack={Slack}   />
                        </div>
                        <div className="md:pl-14 mt-10 md:mt-24">
                            <Description R1={resultData.R1} R2={resultData.R2} R3={resultData.R3} R4={resultData.R4} R5={resultData.R5} Networth={Networth} />
                        </div> 

                     </div> 
                
                     <div className="space-y-10">
                    <div className='flex justify-center'>
                        <h2 className='bg-primary/10 text-primary rounded-xl py-2 px-4 text-base md:text-xl'>Loan Amounts and APRs</h2>
                    </div>
                    <div className="bg-primary/5  rounded-xl p-4">
         

                            {/* <DoubleAxisGraph Loans={[data.CLA, data.CCDA, data.PLA, data.ELA]} APRs={[data.CLAPR, data.CCDAPR
                                , data.PLAPR, data.ELAPR]} /> */}

                        <MultipleAxisGraph Loans={[data.CLA, data.CCDA, data.PLA, data.ELA]} APRs={[data.CLAPR, data.CCDAPR
                            , data.PLAPR, data.ELAPR]} />

              

                        
                    </div>

                
                
                    <div className="flex-1 w-full md:flex-none space-y-6 " >
                    <div className='flex justify-center mb-16'>
                        <h2 className='bg-primary/10 text-primary rounded-xl py-2 px-4 text-base md:text-xl'>Recommendations</h2>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-1 gap-4 md:gap-y-8 lg:gap-x-20 ">


                  {Number(resultData.R2).toFixed(0)>300?
                  
                    <div className="w-full md:flex-1  shadow-md  p-8 ">
                  <div className="px-0 md:px-20">
                     <Heading text="How to pay off debt?" classes={"text-center"} />
                    </div>
                         <div className="flex justify-center pt-5 pb-5 ">
                     <div className="md:w-9/12 md:px-0 md:pl-8 pl-0 px-10 font-bold text-black space-y-7">
                         {
                          PayableLoans.length>0?<p className="font-bold"> {PayableLoans}</p> 
                          :''
                         }
                  </div> 
                       </div>

                     </div> :''

}



                     {/* <div className="w-full md:flex-1  shadow-md  p-8 ">
           
                       <div className="flex justify-center pt-5 pb-5 ">
                   <div className="md:w-10/12 md:px-0 px-10 space-y-7">
                          <p className="     font-bold">You need X amount of months to build your emergency fund.
                       Then you can throw $2000 towards your debt.</p>
             </div> 
               </div>

             </div> */}
    

             {Number(resultData.R2).toFixed(0)==300?
              <div className="w-full md:flex-1  shadow-md  p-8 ">
                 <div className="flex justify-center pt-5 pb-5 ">
                <div className="md:w-10/12 md:px-0 px-10 space-y-7">
                  <p className="text-center font-bold">You can use the slack {Slack} in your monthly budget to start reducing debt.</p>
              </div> 

               </div>
</div>:''
}

   
       {(Number(resultData.R2).toFixed(0))<300?
     <div className="w-full md:flex-1  shadow-md  p-8 ">
      <div className="px-0 md:px-20">
      <Heading text="How to payoff your debt?" classes={"text-center"} />
      </div>
       <div className="flex justify-center pt-5 pb-5 ">
        <div className="md:w-9/12 md:px-0 px-10 space-y-7">
            <p className="text-center font-bold">You have to use slack {Slack} to first build your emergency fund. You need {Math.ceil(resultData.R2Less)} amount of months to build your emergency fund. After that you can throw {Slack} towards your debt</p>
       </div> 
    </div>

     </div>:''
    }
    
    
                     {/* <div className="w-full md:flex-1  shadow-md  p-8 ">
           
                       <div className="flex justify-center pt-5 pb-5 ">
                   <div className="md:w-10/12 md:px-0 px-10 space-y-7">
                          <p className="     font-bold">You need X amount of months to build your emergency fund.
                       Then you can throw $2000 towards your debt.</p>
             </div> 
               </div>

             </div> */}
{/* {(Number(resultData.R2)).toFixed(0)>300 && (months.length>0)?
<div className="w-full md:flex-1  shadow-md  p-8 ">
      <div className="px-0 md:px-20">
      <Heading text={`You will be debt free in ${Math.ceil(Number(data.months))} months`} classes={"text-center"} />
      </div>
       <div className="flex justify-center pt-5 pb-5 ">
        <div className="md:w-9/12 md:px-0 px-10 space-y-7">
            <p className="text-center font-bold">You have to use slack ${Slack} to first build your emergency fund. You need {Math.ceil(Number(data.months))} amount of months to build your emergency fund. After that you can throw ${Slack} towards your debt</p>
       </div> 
    </div>

     </div>:''
} */}
</div>



                    
                        </div>
                        {Number(resultData.R2.toFixed(0))>300?
                <div>
                    
                    <div className="flex-1 w-full md:flex-none space-y-6">
                        <div className="shadow-md p-6 bg-white space-y-12">
                        <Heading text={"Key Financial Metrics (Post Debt Managment)"} icon={"financial-input"} />
                        
                        
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-4 gap-4 md:gap-y-8 lg:gap-x-28 md:ml-7">
                        
                                <ResultInput label={"Debt / Income ratio"} value={isNaN(resultData.R1) || resultData.R1 === Infinity ? 0 : resultData.R1.toFixed(2) + '%'} tooltip={"How much of your income is spent on Debt Payments? Recommended < 20%"} />
                                <ResultInput label={"Expense coverage ratio by savings"} value={isNaN(resultData.R2) || resultData.R2 === Infinity ? 0 : resultData.R2.toFixed(2) + '%'} tooltip={"How many times does your savings cover monthly expenses(expenses, debt and rent)? Recommended>300% (3 months)"} />
                                <ResultInput label={"Assets / Liabilities"} value={isNaN(resultData.R3) || resultData.R3 === Infinity ? 0 : resultData.R3.toFixed(2) + '%'} tooltip={"Ratio of what you have vs what you owe. Recommended>100% (positive net worth)"}/>
                                <ResultInput label={"Assets / (Rent + Debt) coverage"} value={isNaN(resultData.R4) || resultData.R4 === Infinity ? 0 : resultData.R4.toFixed(2) + '%'} tooltip={"How many times can your obligations be covered by assets? Recommended > 1200% (one year) "}/>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-3 gap-4 md:gap-y-4 lg:gap-x-32 md:ml-96     ">
                        
                        <ResultInput label={"Housing cost ratio"} value={isNaN(resultData.R5) || resultData.R5 === Infinity ? 0 : resultData.R5.toFixed(2) + '%'}  tooltip={"How much of your income is spent on housing costs? Recommended < 30% "}/>
                        
                        {months.length>0?
                                <ResultInput label={"Slack in Budget"} value={isNaN(Slack) || Number(Slack)<0 || Slack === Infinity ? 0 : 0 } isLast tooltip={"This is the surplus each month which can be used for goal planning"}/>:
                        <ResultInput label={"Slack in Budget"} value={isNaN(Slack) || Slack === Infinity || Number(Slack)<0  ? 0 :  Slack.toFixed(0)} isLast tooltip={"This is the surplus each month which can be used for goal planning"}/>
                    }
                        </div>
                        <div className='flex justify-center '>
                        <h2 className='bg-primary/10 text-primary mt-10 rounded-xl py-2 px-4 text-base md:text-xl'>Cash Flow Distribution<br></br>(Debt Management)</h2>
                    </div>



                        <div className="block md:flex   px-5">

                        <div className="hidden md:block w-9/12">
                            {
                                months.length>0?
                                <PieGraph   M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} slack={-1} />:
                                <PieGraph  M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} slack={Slack} />
                            }
                        </div>
                        <div className="md:hidden">
                            {
                                months.length>0?
                            <PieGraph heading="Current Cash Flow Distribution" subheading="" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} slack={-1}   />:

                            <PieGraph heading="Current Cash Flow Distribution" subheading="" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} slack={Slack}   />
                            }
                        </div>
    <div className="md:pl-14 mt-10 md:mt-24">
        <Description R1={resultData.R1} R2={resultData.R2} R3={resultData.R3} R4={resultData.R4} R5={resultData.R5} Networth={Networth} />
    </div> 

 </div> 
                    </div>
                    </div> 
                    {months.length>1?
                    <div className="flex-1 mt-10 w-full md:flex-none ">
                    <div className='flex justify-center'>
                        <h2 className='bg-primary/10 text-primary rounded-xl py-2 px-4 text-base md:text-xl'>Debt Reduction & Increase in Net Worth</h2>
                    </div>

                  
                    <div className="p-10  flex justify-center">
                        
<DMLineChart labelMonths={months} LineValues={LineChartValues} slack={Slack}/>
</div>
                    </div>:''
                     }




           
</div>
:''}







                    <BottomNav />
                </div>
                
                       
            

            </Container>
        </div>
    );
};

export default DM;